module.exports = __webpack_public_path__ + "img/icn_stats.2dfd1aba.svg";